<div class="content-detail">
  <div
    class="header-container"
    [ngClass]="{
      'margin-negative': spotVacancy?.length && spotVacancy[0]?.id,
      'margin-positive': !spotVacancy?.length || !spotVacancy[0]?.id
    }"
  >
    <div class="button-group">
      <button
        mat-icon-button
        class="download-button"
        (click)="downloadTenants()"
      >
        <mat-icon>cloud_download</mat-icon>
        {{ "detail-tenant.download" | translate }}
      </button>

      <button
        *ngIf="spotVacancy?.length && spotVacancy[0]?.id"
        class="view-vacancy-button"
        (click)="openVacancy()"
      >
        {{ "detail-tenant.viewVacancy" | translate }}
      </button>
    </div>
  </div>
  <div class="table-header-banner">
    <div class="header-content">
      <h2 class="table-title">
        {{ "detail-tenant.title" | translate }}
        <a [href]="'property/' + id + '/lang/' + browserLang" target="_blank">{{
          data?.title | langSelector
        }}</a>
      </h2>
      <div class="toggle-container">
        <div class="toggle-switch">
          <span class="toggle-label">{{
            "detail-tenant.summary" | translate
          }}</span>
          <label class="switch">
            <input
              [(ngModel)]="isDetail"
              type="checkbox"
              (ngModelChange)="onDetailToggle($event)"
            />
            <span class="slider"></span>
          </label>
          <span class="toggle-label">{{
            "detail-tenant.detail" | translate
          }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="table-content ">
    <table class="table table-bordered text-center">
      <thead>
        <tr>
          <th
            class="col-area-small cell-content"
            *ngIf="currentCode == 'mx' && data?.buildingType?.id == 3001"
          >
            {{ "detail-tenant.shop" | translate }}
          </th>
          <th class="col-area" *ngIf="data?.buildingType?.id == 3001">
            {{ "detail-tenant.area" | translate }}
          </th>

          <th class="col-warehouse" *ngIf="data?.buildingType?.id == 1001">
            {{ "detail-tenant.warehouse" | translate }}
          </th>

          <th class="col-module" *ngIf="data?.buildingType?.id == 1001">
            {{ "detail-tenant.module" | translate }}
          </th>

          <th
            class="col-area-small cell-content"
            *ngIf="data?.buildingType?.id == 1001"
          >
            {{ "detail-tenant.area" | translate }}
          </th>
          <th
            class="col-area-small cell-content"
            *ngIf="currentCode == 'mx' && data?.buildingType?.id == 1001"
          >
            {{ "detail-tenant.areaFt" | translate }}
          </th>
          <th
            class="col-efficiency cell-content"
            *ngIf="data?.buildingType?.id == 1001"
          >
            {{ "detail-tenant.moduleEfficiency" | translate }}
          </th>

          <th
            class="col-docks cell-content"
            *ngIf="data?.buildingType?.id == 1001"
          >
            {{ "detail-tenant.docksModule" | translate }}
          </th>

          <th class="col-floor" *ngIf="data?.buildingType?.id == 2001">
            {{ "detail-tenant.floor" | translate }}
          </th>

          <th class="col-suite" *ngIf="data?.buildingType?.id == 2001">
            {{ "detail-tenant.suite" | translate }}
          </th>

          <th class="col-private-area" *ngIf="data?.buildingType?.id == 2001">
            {{ "detail-tenant.privateArea" | translate }}
          </th>
          <th
            class="col-area-small cell-content"
            *ngIf="currentCode == 'mx' && data?.buildingType?.id != 1001"
          >
            {{ "detail-tenant.areaFt" | translate }}
          </th>

          <th
            class="col-boma-area"
            *ngIf="data?.buildingType?.id == 2001 && currentCode == 'br'"
          >
            {{ "detail-tenant.bomaArea" | translate }}
          </th>

          <th
            class="col-area-small cell-content"
            *ngIf="currentCode == 'mx' && data?.buildingType?.id == 3001"
          >
            {{ "detail-tenant.typeOf" | translate }}
          </th>

          <th class="col-tenant-name">
            {{ "detail-tenant.tenantName" | translate }}
          </th>

          <th
            class="col-industry"
            *ngIf="data?.buildingType?.id != 3001 || currentCode == 'mx'"
          >
            {{ "detail-tenant.industry" | translate }}
          </th>

          <th class="col-contact">
            {{ "detail-tenant.contactInformation" | translate }}
          </th>

          <th class="col-owner" *ngIf="currentCode == 'br'">
            {{ "detail-tenant.ownerInformation" | translate }}
          </th>

          <th class="col-date">
            {{ "detail-tenant.dateEntered" | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let tenant of list">
          <td *ngIf="currentCode == 'mx' && data?.buildingType?.id == 3001">
            <mat-icon *ngIf="isAdmin" (click)="editTenantDetail(tenant, false)"
              >edit</mat-icon
            >
            {{
              tenant?.suiteNumberAlias
                ? tenant?.suiteNumberAlias
                : tenant?.suiteNumber
            }}
          </td>
          <td *ngIf="data?.buildingType?.id == 3001">
            {{ tenant?.area | localNumber: "1.2-2" }}
          </td>
          <td
            *ngIf="
              data?.buildingType?.id == 1001 && data?.buildingType?.id != 3001
            "
          >
            <mat-icon *ngIf="isAdmin" (click)="editTenantDetail(tenant, false)"
              >edit</mat-icon
            >{{
              tenant?.warehouseAlias
                ? tenant?.warehouseAlias
                : tenant?.warehouse
            }}
          </td>

          <td
            *ngIf="
              data?.buildingType?.id == 2001 && data?.buildingType?.id != 3001
            "
          >
            <mat-icon *ngIf="isAdmin" (click)="editTenantDetail(tenant, false)"
              >edit</mat-icon
            >{{ tenant?.floorAlias ? tenant?.floorAlias : tenant?.floor }}
          </td>
          <td
            *ngIf="
              data?.buildingType?.id == 1001 && data?.buildingType?.id != 3001
            "
          >
            {{ tenant?.moduleAlias ? tenant?.moduleAlias : tenant?.module }}
          </td>
          <td
            *ngIf="
              data?.buildingType?.id == 2001 && data?.buildingType?.id != 3001
            "
          >
            {{
              tenant?.suiteNumberAlias
                ? tenant?.suiteNumberAlias
                : tenant?.suiteNumber
            }}
          </td>
          <td
            *ngIf="
              data?.buildingType?.id == 1001 && data?.buildingType?.id != 3001
            "
          >
            {{ tenant?.area | localNumber: "1.2-2" }}
          </td>
          <td
            *ngIf="
              data?.buildingType?.id == 2001 && data?.buildingType?.id != 3001
            "
          >
            {{ tenant?.area | localNumber: "1.2-2" }}
          </td>
          <td *ngIf="currentCode == 'mx'">
            {{ tenant?.area * 10.7639 | localNumber: "1.2-2" }}
          </td>
          <td *ngIf="currentCode == 'mx' && data?.buildingType?.id == 3001">
            {{ tenant?.spaceTypeRetail.name | langSelector }}
          </td>

          <td
            *ngIf="
              data?.buildingType?.id == 1001 && data?.buildingType?.id != 3001
            "
          >
            {{ tenant?.moduleEfficiency }}
          </td>
          <td
            *ngIf="
              data?.buildingType?.id == 2001 &&
              currentCode == 'br' &&
              data?.buildingType?.id != 3001
            "
          >
            {{ tenant?.bomaArea | localNumber: "1.2-2" }}
          </td>
          <td
            *ngIf="
              data?.buildingType?.id == 1001 && data?.buildingType?.id != 3001
            "
          >
            {{ tenant?.docksPerModule }}
          </td>
          <td>
            {{
              tenant?.tenantName
                ? tenant?.tenantName
                : (tenant?.tenantNameOption?.name | langSelector)
            }}
          </td>
          <td *ngIf="data?.buildingType?.id != 3001 || currentCode == 'mx'">
            {{
              data?.buildingType?.id == 3001
                ? (tenant?.industryRetail?.name | langSelector)
                : tenant?.marketSegment?.name
                ? (tenant?.marketSegment?.name | langSelector)
                : tenant?.tenantName == null &&
                  validateTenantOption(
                    tenant?.tenantNameOption?.name | langSelector
                  )
                ? "N/A"
                : ""
            }}
          </td>

          <td>
            <div>
              <span
                *ngIf="
                  (!isDetail &&
                    validateContactInformation(tenant) &&
                    !showContactMap.get(tenant.id)) ||
                  (!isDetail && validateContactInformation(tenant) == null)
                "
                (click)="toggleDetailsContact(tenant.id)"
                [ngClass]="
                  validateContactInformation(tenant) != null ? 'view-link' : ''
                "
              >
                {{
                  validateContactInformation(tenant) == null
                    ? "N/A"
                    : ("detail-tenant.view" | translate)
                }}
              </span>
            </div>
            <div
              class="information-column"
              *ngIf="
                (isDetail && validateContactInformation(tenant)) ||
                (showContactMap.get(tenant.id) &&
                  validateContactInformation(tenant)) ||
                (isDetail && validateContactInformation(tenant) == null)
              "
            >
              <div class="tenant-contact-container">
                <div style="display: grid;">
                  <span>{{ tenant?.tenantContactName }}</span>
                  <span> {{ tenant?.tenantContactPhone }} </span>
                  <span>{{ tenant?.tenantContactEmail }}</span>
                  <span
                    *ngIf="
                      isDetail && validateContactInformation(tenant) == null
                    "
                    >N/A</span
                  >
                </div>
                <div style="margin: -8px; margin-left: -5px;">
                  <button
                    mat-icon-button
                    *ngIf="validateContactInformation(tenant)"
                    (click)="copyTenantInfo(tenant)"
                    aria-label="Copy"
                    class="copy-button"
                  >
                    <mat-icon>file_copy</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </td>

          <td *ngIf="currentCode == 'br'">
            <div>
              <span
                *ngIf="
                  !isDetail &&
                  validateOwnersInformation(tenant) &&
                  !showOwnerMap.get(tenant.id)
                "
                (click)="toggleDetailsOwner(tenant.id)"
                class="view-link"
              >
                {{ "detail-tenant.view" | translate }}
              </span>
            </div>
            <div
              class="information-column"
              *ngIf="
                isDetail ||
                !validateOwnersInformation(tenant) ||
                showOwnerMap.get(tenant.id)
              "
            >
              <span>{{ tenant?.owners }}</span>
              <span>{{ tenant?.ownersGroup }}</span>
              <span>{{ tenant?.ownersContactName }}</span>
              <span>{{ tenant?.ownersContactPhone }}</span>
              <span>{{ tenant?.ownersContactEmail }}</span>
            </div>
          </td>
          <td>{{ tenant?.dateEntered | date: "yyyy-MM-dd" }}</td>
        </tr>
      </tbody>
    </table>
    <div class="buttons-container">
      <div class="add-row-container">
        <button
          class="add-row-button"
          (click)="editTenantDetail(null, true)"
          *ngIf="editValidation()"
        >
          {{ "detail-tenant.addNewRow" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
